<div class="beautiful-card" 
     data-test="documents-panel" 
     [ngClass]="getCardStatusClass(document)" 
     (click)="isDisabled ? null : navigateToUpload(document.name)">
  <div class="card-header">
    <div class="status-indicator">
      <mat-icon class="status-icon">{{ getStatusIcon(document) }}</mat-icon>
    </div>
    <div class="document-icon-container">
      <mat-icon [svgIcon]="getDocumentIcon(document)" class="document-icon"></mat-icon>
    </div>
  </div>
  <div class="card-content">
    <h3 class="document-title" data-test="document-name">{{ document?.displayName }}</h3>
    <p class="document-status">{{ getStatusText(document) }}</p>
  </div>
</div>
